import { create, defaulted, Describe, nullable, optional, string, type } from 'superstruct';

import { MediaLibraryConfig } from '~modules/media-library/model/Config';

export const MediaLibraryConfigValidator: Describe<Required<MediaLibraryConfig>> = defaulted(
  type({
    realm: optional(nullable(string())),
  }),
  {
    realm: '',
  },
);

export default (rawConfig: string): MediaLibraryConfig => {
  let config: Partial<MediaLibraryConfig>;
  try {
    config = JSON.parse(rawConfig);
  } catch (_error) {
    config = {};
  }

  return create(config, MediaLibraryConfigValidator);
};
